import { ContentIdAndDefaultValue } from 'src/contexts/ContentContext';

import { FormatContentId } from './formatContentId';

// Please keep this map in alphabetical order
export const FormatContentIds: Record<
  FormatContentId,
  ContentIdAndDefaultValue
> = {
  [FormatContentId.ActivityLogChangeFromTo]: {
    id: FormatContentId.ActivityLogChangeFromTo,
    defaultValue: '{0} changed from {1} to {2}',
  },
  [FormatContentId.ActivityLogChangeFrom]: {
    id: FormatContentId.ActivityLogChangeFrom,
    defaultValue: '{0} changed from {1} to nothing.',
  },
  [FormatContentId.ActivityLogChangeTo]: {
    id: FormatContentId.ActivityLogChangeTo,
    defaultValue: '{0} changed to {1}',
  },
  [FormatContentId.AddAnother]: {
    id: FormatContentId.AddAnother,
    defaultValue: 'Add Another {0}',
  },
  [FormatContentId.AddSeatingToCart]: {
    id: FormatContentId.AddSeatingToCart,
    defaultValue: 'Add {0} {1} to cart',
  },
  [FormatContentId.AdjustFxRatePurchaseOrder]: {
    id: FormatContentId.AdjustFxRatePurchaseOrder,
    defaultValue: 'Adjust FX Rate — PO #{0}',
  },
  [FormatContentId.AllocateRetailPayment]: {
    id: FormatContentId.AllocateRetailPayment,
    defaultValue:
      'Allocate the partial payment of {0} across the unpaid line items below. The total must equal the partial amount.',
  },
  [FormatContentId.AllOnThisPageSelected]: {
    id: FormatContentId.AllOnThisPageSelected,
    defaultValue: 'All {0} on this page',
  },
  [FormatContentId.AndXMore]: {
    id: FormatContentId.AndXMore,
    defaultValue: '& {0} more',
  },
  [FormatContentId.ApplyFilterToReduceCountsToSeeData]: {
    id: FormatContentId.ApplyFilterToReduceCountsToSeeData,
    defaultValue:
      'Your current filter returns more than {0} items. Please select additional filters to view your data.',
  },
  [FormatContentId.AutoPricedListingsRollupMetric]: {
    id: FormatContentId.AutoPricedListingsRollupMetric,
    defaultValue: 'Auto-Priced Listings: {0}',
  },
  [FormatContentId.AvgOfTheXCheapestListings]: {
    id: FormatContentId.AvgOfTheXCheapestListings,
    defaultValue: 'Avg of the {0} cheapest listings',
  },
  [FormatContentId.ApplyToAllEventsConfirmation]: {
    id: FormatContentId.ApplyToAllEventsConfirmation,
    defaultValue:
      'Do you want to apply the heat map to all {0} {1} events at {2} or only to this event?',
  },
  [FormatContentId.BaseBidExceedsBudgetError]: {
    id: FormatContentId.BaseBidExceedsBudgetError,
    defaultValue: "Bid Amount can't exceed {0}.",
  },
  [FormatContentId.BoostNEvents]: {
    id: FormatContentId.BoostNEvents,
    defaultValue: 'Boost: {0} event(s)',
  },
  [FormatContentId.BroadcastStatusRollupMetric]: {
    id: FormatContentId.BroadcastStatusRollupMetric,
    defaultValue: 'Broadcast Status: {0} of {1}',
  },
  [FormatContentId.BulkEditMaxItemPreviewDisplayMessage]: {
    id: FormatContentId.BulkEditMaxItemPreviewDisplayMessage,
    defaultValue: 'Only a maximum of {0} of {1} is displayed for preview.',
  },
  [FormatContentId.BulkEditSkippedItemsPrompt]: {
    id: FormatContentId.BulkEditSkippedItemsPrompt,
    defaultValue:
      '{0} items were skipped because their associated entities were changed. Click Retry to try editing them again.',
  },
  [FormatContentId.BuyFromMarketNTickets]: {
    id: FormatContentId.BuyFromMarketNTickets,
    defaultValue: 'Buy from Market ({0} tickets)',
  },
  [FormatContentId.ChargeTotalDiscrepancy]: {
    id: FormatContentId.ChargeTotalDiscrepancy,
    defaultValue:
      'Charge Total Discrepancy is {0} but payment line charge total is {1}',
  },
  [FormatContentId.ClassifyAs]: {
    id: FormatContentId.ClassifyAs,
    defaultValue: 'Classify as {0}',
  },
  [FormatContentId.ClearSelections]: {
    id: FormatContentId.ClearSelections,
    defaultValue: 'Clear {0} selections',
  },
  [FormatContentId.ConfigOption]: {
    id: FormatContentId.ConfigOption,
    defaultValue: 'Config {0}',
  },
  [FormatContentId.ConfigOptionWithDetail]: {
    id: FormatContentId.ConfigOptionWithDetail,
    defaultValue: 'Config {0} — {1}',
  },
  [FormatContentId.CostPerEventAmount]: {
    id: FormatContentId.CostPerEventAmount,
    defaultValue: '{0} {1} per event',
  },
  [FormatContentId.CostPerEventDistributed]: {
    id: FormatContentId.CostPerEventDistributed,
    defaultValue: 'Cost per event: {0} {1} — auto-distributed by quantity',
  },
  [FormatContentId.CurrencyOriginal]: {
    id: FormatContentId.CurrencyOriginal,
    defaultValue: '{0} (Original)',
  },
  [FormatContentId.CompletedNSecondsAgo]: {
    id: FormatContentId.CompletedNSecondsAgo,
    defaultValue: 'Completed {0} seconds ago.',
  },
  [FormatContentId.CompletedNMinutesAgo]: {
    id: FormatContentId.CompletedNMinutesAgo,
    defaultValue: 'Completed {0} minutes ago.',
  },
  [FormatContentId.CompletedNHoursAgo]: {
    id: FormatContentId.CompletedNHoursAgo,
    defaultValue: 'Completed {0} hours ago.',
  },
  [FormatContentId.CopyOf]: {
    id: FormatContentId.CopyOf,
    defaultValue: 'Copy of {0}',
  },
  [FormatContentId.CouldNotFindListingId]: {
    id: FormatContentId.CouldNotFindListingId,
    defaultValue: "Could not find Listing Id: '{0}'",
  },
  [FormatContentId.CouldNotFindOrderId]: {
    id: FormatContentId.CouldNotFindOrderId,
    defaultValue: "Could not find Order Id: '{0}'",
  },
  [FormatContentId.CouldNotFindPaymentId]: {
    id: FormatContentId.CouldNotFindPaymentId,
    defaultValue: 'Could not find Payment ID: {0}',
  },
  [FormatContentId.CouldNotFindSaleId]: {
    id: FormatContentId.CouldNotFindSaleId,
    defaultValue: "Could not find Sale Id: '{0}'",
  },
  [FormatContentId.CreatePurchaseOrderProgressTracker]: {
    id: FormatContentId.CreatePurchaseOrderProgressTracker,
    defaultValue: '{0} ticket groups created across {1} events.',
  },
  [FormatContentId.CreditTotalDiscrepancy]: {
    id: FormatContentId.CreditTotalDiscrepancy,
    defaultValue:
      'Credit Total Discrepancy is {0} but payment line credit total is {1}',
  },
  [FormatContentId.EditBudgetForActiveFlightOnly]: {
    id: FormatContentId.EditBudgetForActiveFlightOnly,
    defaultValue: "Adjust {0}'s budget cap only (ending {1})",
  },
  [FormatContentId.EventNumber]: {
    id: FormatContentId.EventNumber,
    defaultValue: 'Event {0}',
  },
  [FormatContentId.ExportDateRangeExceedsAvailableData]: {
    id: FormatContentId.ExportDateRangeExceedsAvailableData,
    defaultValue: 'End date exceeds available data (through {0}).',
  },
  [FormatContentId.FlightNumberX]: {
    id: FormatContentId.FlightNumberX,
    defaultValue: 'Flight #{0}',
  },
  [FormatContentId.FloorPriceRollupMetric]: {
    id: FormatContentId.FloorPriceRollupMetric,
    defaultValue: 'Floor Price: {0}',
  },
  [FormatContentId.InheritedFromListing]: {
    id: FormatContentId.InheritedFromListing,
    defaultValue: 'Inherited from Listing #{0}',
  },
  [FormatContentId.InheritedFromPurchase]: {
    id: FormatContentId.InheritedFromPurchase,
    defaultValue: 'Inherited from Purchase #{0}',
  },
  [FormatContentId.MemoryUsageExceeded]: {
    id: FormatContentId.MemoryUsageExceeded,
    defaultValue:
      'Memory usage is currently too high ({0}). Click button to free some memory. If problem still persists, close some browser tabs.',
  },
  [FormatContentId.NextNDays]: {
    id: FormatContentId.NextNDays,
    defaultValue: 'Next {0} Days',
  },
  [FormatContentId.NextNYear]: {
    id: FormatContentId.NextNYear,
    defaultValue: 'Next {0} Year',
  },
  [FormatContentId.NFiltersSelected]: {
    id: FormatContentId.NFiltersSelected,
    defaultValue: '{0} filters selected',
  },
  [FormatContentId.NSucceededMFailed]: {
    id: FormatContentId.NSucceededMFailed,
    defaultValue: '{0} succeeded, {1} failed',
  },
  [FormatContentId.NTickets]: {
    id: FormatContentId.NTickets,
    defaultValue: '{0} tickets',
  },
  [FormatContentId.NTicketsTimesPrice]: {
    id: FormatContentId.NTicketsTimesPrice,
    defaultValue: '{0} tickets × {1}',
  },
  [FormatContentId.OfValue]: {
    id: FormatContentId.OfValue,
    defaultValue: 'of {0}',
  },
  [FormatContentId.PageOfPages]: {
    id: FormatContentId.PageOfPages,
    defaultValue: 'Page {0} of {1}',
  },
  [FormatContentId.PartialPaymentValidationMessage]: {
    id: FormatContentId.PartialPaymentValidationMessage,
    defaultValue:
      'Partial payment must be greater than zero and less than total amount {0}.',
  },
  [FormatContentId.PaymentTotalDiscrepancy]: {
    id: FormatContentId.PaymentTotalDiscrepancy,
    defaultValue: 'Payment Total is {0} but payment lines total is {1}',
  },
  [FormatContentId.PlaceholderEventGroupAllocatedSummary]: {
    id: FormatContentId.PlaceholderEventGroupAllocatedSummary,
    defaultValue: '{0} of {1} events allocated',
  },
  [FormatContentId.PlusCountMore]: {
    id: FormatContentId.PlusCountMore,
    defaultValue: '{0} + {1} more',
  },
  [FormatContentId.PriceConflictRollupMetric]: {
    id: FormatContentId.PriceConflictRollupMetric,
    defaultValue: 'Price in Conflict: {0}',
  },
  [FormatContentId.ProceedsTotalDiscrepancy]: {
    id: FormatContentId.ProceedsTotalDiscrepancy,
    defaultValue:
      'Proceeds Total Discrepancy is {0} but payment line proceeds total is {1}',
  },
  [FormatContentId.PurchaseCompleteSummary]: {
    id: FormatContentId.PurchaseCompleteSummary,
    defaultValue: 'Purchase Complete ({0} succeeded, {1} failed)',
  },
  [FormatContentId.RankPremiumRollupMetric]: {
    id: FormatContentId.RankPremiumRollupMetric,
    defaultValue: 'Rank Premium: {0}',
  },
  [FormatContentId.RecommendedSections]: {
    id: FormatContentId.RecommendedSections,
    defaultValue: '{0} Sections',
  },
  [FormatContentId.RemainingBudget]: {
    id: FormatContentId.RemainingBudget,
    defaultValue: '{0} budget remaining',
  },
  [FormatContentId.RemoveSeatingFromCart]: {
    id: FormatContentId.RemoveSeatingFromCart,
    defaultValue: 'Remove {0} {1} from cart',
  },
  [FormatContentId.SaveAsDefaultConfig]: {
    id: FormatContentId.SaveAsDefaultConfig,
    defaultValue: '{0} similar events and venue configs at this venue',
  },
  [FormatContentId.SellThroughRateRollupMetric]: {
    id: FormatContentId.SellThroughRateRollupMetric,
    defaultValue: 'Sell Through Rate: {0}',
  },
  [FormatContentId.SoldListingsRollupMetric]: {
    id: FormatContentId.SoldListingsRollupMetric,
    defaultValue: 'Sold Listings: {0}',
  },
  [FormatContentId.SoldTicketsMetric]: {
    id: FormatContentId.SoldTicketsMetric,
    defaultValue: '{0} tickets sold',
  },
  [FormatContentId.ValueOfValue]: {
    id: FormatContentId.ValueOfValue,
    defaultValue: '{0} of {1}',
  },
  [FormatContentId.VenueCapacity]: {
    id: FormatContentId.VenueCapacity,
    defaultValue: 'Cap: {0}',
  },
  [FormatContentId.ViewAllocReset]: {
    id: FormatContentId.ViewAllocReset,
    defaultValue: 'View allocations reset every {0} days',
  },
  [FormatContentId.DaysBeforeEvent]: {
    id: FormatContentId.DaysBeforeEvent,
    defaultValue: '{0} Days Before Event',
  },
  [FormatContentId.DuplicateListingDetails]: {
    id: FormatContentId.DuplicateListingDetails,
    defaultValue:
      'This listing appears to be a duplicate of listing {0}. We suggest removing it.',
  },
  [FormatContentId.DuplicatingSeats]: {
    id: FormatContentId.DuplicatingSeats,
    defaultValue: 'Duplicating seat found for Seat {0}',
  },
  [FormatContentId.EmailAddressFrom]: {
    id: FormatContentId.EmailAddressFrom,
    defaultValue: 'From: {0}',
  },
  [FormatContentId.EmailAddressTo]: {
    id: FormatContentId.EmailAddressTo,
    defaultValue: 'To: {0}',
  },
  [FormatContentId.EmptyContent]: {
    id: FormatContentId.EmptyContent,
    defaultValue: '',
  },
  [FormatContentId.EventDiscoProceedsAdvantageInEffect]: {
    id: FormatContentId.EventDiscoProceedsAdvantageInEffect,
    defaultValue:
      'Event Discovery is active, so a preferred proceeds rate of {0} will apply whenever your current markup is less than this amount.',
  },
  [FormatContentId.EventsSelected]: {
    id: FormatContentId.EventsSelected,
    defaultValue: '{0} event(s) selected',
  },
  [FormatContentId.EventViews]: {
    id: FormatContentId.EventViews,
    defaultValue: '{0} Event views',
  },
  [FormatContentId.EventViewsRemaining]: {
    id: FormatContentId.EventViewsRemaining,
    defaultValue: '{0} Event Views Remaining',
  },
  [FormatContentId.ExtraBarcodes]: {
    id: FormatContentId.ExtraBarcodes,
    defaultValue: '{0} extra barcode(s).',
  },
  [FormatContentId.ExtraTicketIds]: {
    id: FormatContentId.ExtraTicketIds,
    defaultValue: '{0} extra ticket id(s).',
  },
  [FormatContentId.ExtraTicketUrls]: {
    id: FormatContentId.ExtraTicketUrls,
    defaultValue: '{0} extra URL(s).',
  },
  [FormatContentId.Filled]: {
    id: FormatContentId.Filled,
    defaultValue: '{0} Filled',
  },
  [FormatContentId.FirstTimeVenueEventSetup]: {
    id: FormatContentId.FirstTimeVenueEventSetup,
    defaultValue: 'The venue for this event is setup as {0}',
  },
  [FormatContentId.FulfilledExternalMarketplace]: {
    id: FormatContentId.FulfilledExternalMarketplace,
    defaultValue:
      'This order is fulfilled on {0}. To fulfill with new tickets, you will need to get {0} to reset the fulfilment state of the order.',
  },
  [FormatContentId.GoTo]: {
    id: FormatContentId.GoTo,
    defaultValue: 'Go to {0}',
  },
  [FormatContentId.HurdleN]: {
    id: FormatContentId.HurdleN,
    defaultValue: 'Hurdle {0}',
  },
  [FormatContentId.InNDays]: {
    id: FormatContentId.InNDays,
    defaultValue: 'In {0} days',
  },
  [FormatContentId.InNHours]: {
    id: FormatContentId.InNHours,
    defaultValue: 'In {0} hours',
  },
  [FormatContentId.InNMinutes]: {
    id: FormatContentId.InNMinutes,
    defaultValue: 'In {0} minutes',
  },
  [FormatContentId.InvalidTagCharacter]: {
    id: FormatContentId.InvalidTagCharacter,
    defaultValue: 'Special characters not allowed: {0}',
  },
  [FormatContentId.ItemsSelected]: {
    id: FormatContentId.ItemsSelected,
    defaultValue: '{0} items selected',
  },
  [FormatContentId.LastNDays]: {
    id: FormatContentId.LastNDays,
    defaultValue: 'last {0} days',
  },
  [FormatContentId.LastNHours]: {
    id: FormatContentId.LastNHours,
    defaultValue: 'last {0} hours',
  },
  [FormatContentId.LastNMinutes]: {
    id: FormatContentId.LastNMinutes,
    defaultValue: 'last {0} minutes',
  },
  [FormatContentId.LastNMonths]: {
    id: FormatContentId.LastNMonths,
    defaultValue: 'last {0} months',
  },
  [FormatContentId.ListingInUKNotification]: {
    id: FormatContentId.ListingInUKNotification,
    defaultValue:
      'Direct listing on {0} not supported. Redirecting to {0} in {1} seconds...',
  },
  [FormatContentId.LoadingListingId]: {
    id: FormatContentId.LoadingListingId,
    defaultValue: "Loading Listing Id '{0}'",
  },
  [FormatContentId.LoadingOrderId]: {
    id: FormatContentId.LoadingOrderId,
    defaultValue: "Loading Order Id '{0}'",
  },
  [FormatContentId.LoadingSaleId]: {
    id: FormatContentId.LoadingSaleId,
    defaultValue: "Loading Sale Id '{0}'",
  },
  [FormatContentId.Margin]: {
    id: FormatContentId.Margin,
    defaultValue: '{0} Margin',
  },
  [FormatContentId.MarketOrders_NoListingsMatchFilters]: {
    id: FormatContentId.MarketOrders_NoListingsMatchFilters,
    defaultValue: 'No listings match the current filters ({0} total)',
  },
  [FormatContentId.MarketplaceListings]: {
    id: FormatContentId.MarketplaceListings,
    defaultValue: '{0} Marketplace listings',
  },
  [FormatContentId.MaxAllowedFileSizeMb]: {
    id: FormatContentId.MaxAllowedFileSizeMb,
    defaultValue: 'File maximum size allowed is {0} MB',
  },
  [FormatContentId.MaxReportSizeWarningMessage]: {
    id: FormatContentId.MaxReportSizeWarningMessage,
    defaultValue:
      'Your report has {0} rows but only {1} is returned per maximum recommended. To view your entire report, either download it or bypass the recommended limit.',
  },
  [FormatContentId.MedianPriceWarning]: {
    id: FormatContentId.MedianPriceWarning,
    defaultValue: 'This is {0}% {1} the current median listing price.',
  },
  [FormatContentId.MinDiscountContent]: {
    id: FormatContentId.MinDiscountContent,
    defaultValue: 'Discount must be at least {0}',
  },
  [FormatContentId.MissingBarcodes]: {
    id: FormatContentId.MissingBarcodes,
    defaultValue: '{0} missing barcode(s).',
  },
  [FormatContentId.MissingTicketIds]: {
    id: FormatContentId.MissingTicketIds,
    defaultValue: '{0} missing ticket id(s).',
  },
  [FormatContentId.MissingTicketUrls]: {
    id: FormatContentId.MissingTicketUrls,
    defaultValue: '{0} missing URL(s).',
  },
  [FormatContentId.NCharactersRemaining]: {
    id: FormatContentId.NCharactersRemaining,
    defaultValue: '{0} characters remaining',
  },
  [FormatContentId.NCompleted]: {
    id: FormatContentId.NCompleted,
    defaultValue: '{0} completed',
  },
  [FormatContentId.NDays]: {
    id: FormatContentId.NDays,
    defaultValue: '{0} days',
  },
  [FormatContentId.NEventsAlreadyActive]: {
    id: FormatContentId.NEventsAlreadyActive,
    defaultValue: '{0} event(s) already active',
  },
  [FormatContentId.NEventsToBeBoosted]: {
    id: FormatContentId.NEventsToBeBoosted,
    defaultValue: '{0} event(s) to be boosted',
  },
  [FormatContentId.NFailed]: {
    id: FormatContentId.NFailed,
    defaultValue: '{0} failed',
  },
  [FormatContentId.NHours]: {
    id: FormatContentId.NHours,
    defaultValue: '{0} hours',
  },
  [FormatContentId.NIncreaseBy]: {
    id: FormatContentId.NIncreaseBy,
    defaultValue: 'Increase by {0}',
  },
  [FormatContentId.NMinutes]: {
    id: FormatContentId.NMinutes,
    defaultValue: '{0} minutes',
  },
  [FormatContentId.NDaysBefore]: {
    id: FormatContentId.NDaysBefore,
    defaultValue: '{0} days before event',
  },
  [FormatContentId.NHoursBefore]: {
    id: FormatContentId.NHoursBefore,
    defaultValue: '{0} hours before event',
  },
  [FormatContentId.NMinutesBefore]: {
    id: FormatContentId.NMinutesBefore,
    defaultValue: '{0} minutes before event',
  },
  [FormatContentId.NPausedEventsWillBeRestarted]: {
    id: FormatContentId.NPausedEventsWillBeRestarted,
    defaultValue: '{0} paused event(s) will be restarted',
  },
  [FormatContentId.NoDataAvailable]: {
    id: FormatContentId.NoDataAvailable,
    defaultValue: 'No {0} Available',
  },
  [FormatContentId.NotificationTypeListingBroadcastFailed]: {
    id: FormatContentId.NotificationTypeListingBroadcastFailed,
    defaultValue: 'Failed to broadcast listing to {0}',
  },
  [FormatContentId.NotificationTypeListingUpdateAllInPriceFailed]: {
    id: FormatContentId.NotificationTypeListingUpdateAllInPriceFailed,
    defaultValue: '{0} price broadcast failed',
  },
  [FormatContentId.NotificationTypeListingUpdateInHandDateFailed]: {
    id: FormatContentId.NotificationTypeListingUpdateInHandDateFailed,
    defaultValue: '{0} In Hand Date broadcast failed',
  },
  [FormatContentId.NotificationTypeListingUpdateSplitTypeFailed]: {
    id: FormatContentId.NotificationTypeListingUpdateSplitTypeFailed,
    defaultValue: '{0} Split Type update broadcast failed',
  },
  [FormatContentId.NotificationTypeListingUpdateTicketTypeFailed]: {
    id: FormatContentId.NotificationTypeListingUpdateTicketTypeFailed,
    defaultValue: '{0} Ticket Type update broadcast failed',
  },
  [FormatContentId.NotificationTypeListingUpdateUnitNetProceedsFailed]: {
    id: FormatContentId.NotificationTypeListingUpdateUnitNetProceedsFailed,
    defaultValue: '{0} price broadcast failed',
  },
  [FormatContentId.NotificationTypeListingUnbroadcastFailed]: {
    id: FormatContentId.NotificationTypeListingUnbroadcastFailed,
    defaultValue: 'Failed to unbroadcast listing from {0}',
  },
  [FormatContentId.NotificationTypeSellerSupportCaseNewReply]: {
    id: FormatContentId.NotificationTypeSellerSupportCaseNewReply,
    defaultValue: 'New message from {0}',
  },
  [FormatContentId.NotUnique]: {
    id: FormatContentId.NotUnique,
    defaultValue: '{0} is not unique',
  },
  [FormatContentId.NSelected]: {
    id: FormatContentId.NSelected,
    defaultValue: '{0} Selected',
  },
  [FormatContentId.NSelectedSections]: {
    id: FormatContentId.NSelectedSections,
    defaultValue: '{0} selected sections',
  },
  [FormatContentId.NUpdated]: {
    id: FormatContentId.NUpdated,
    defaultValue: '{0} updated',
  },
  [FormatContentId.NWarnings]: {
    id: FormatContentId.NWarnings,
    defaultValue: '{0} warnings',
  },
  [FormatContentId.OnlyForMarketplaces]: {
    id: FormatContentId.OnlyForMarketplaces,
    defaultValue: '(for {0} only)',
  },
  [FormatContentId.OnSaleEventAccessCreditRenewal]: {
    id: FormatContentId.OnSaleEventAccessCreditRenewal,
    defaultValue: 'Event views renew every {0} days, unless cancelled.',
  },
  [FormatContentId.OnSaleEventProceedsMarkup]: {
    id: FormatContentId.OnSaleEventProceedsMarkup,
    defaultValue: '{0} proceeds markup',
  },
  [FormatContentId.PacksOf]: {
    id: FormatContentId.PacksOf,
    defaultValue: 'Packs of {0}',
  },
  [FormatContentId.PageNum]: {
    id: FormatContentId.PageNum,
    defaultValue: 'Page {0}',
  },
  [FormatContentId.PercentageRelativeTo]: {
    id: FormatContentId.PercentageRelativeTo,
    defaultValue: 'Percentage Relative to {0}',
  },
  [FormatContentId.ProofOfPurchasedRequiredDetailMessage]: {
    id: FormatContentId.ProofOfPurchasedRequiredDetailMessage,
    defaultValue:
      'Seated tickets must either have row or seat information, or proof submitted that you do not have this information available to you, before they can appear on {0}.',
  },
  [FormatContentId.RequestState]: {
    id: FormatContentId.RequestState,
    defaultValue: 'Request State: {0}',
  },
  [FormatContentId.Row]: {
    id: FormatContentId.Row,
    defaultValue: 'Row {0}',
  },
  [FormatContentId.RowRangeInputError]: {
    id: FormatContentId.RowRangeInputError,
    defaultValue: 'Upper bond of the row range must be no less than {0}.',
  },
  [FormatContentId.SalesForEditTickets]: {
    id: FormatContentId.SalesForEditTickets,
    defaultValue:
      'If your edits result in one or more tickets removed, your {0} sales for the removed tickets will be deallocated and put back to Pending Confirmation, where you can either source new tickets or reject the orders.',
  },
  [FormatContentId.SalesForRemovedTickets]: {
    id: FormatContentId.SalesForRemovedTickets,
    defaultValue:
      'Your {0} sales for the removed tickets will be deallocated and put back to Pending Confirmation, where you can either source new tickets or reject the orders.',
  },
  [FormatContentId.SearchItem]: {
    id: FormatContentId.SearchItem,
    defaultValue: 'Search {0}',
  },
  [FormatContentId.SearchingForListingId]: {
    id: FormatContentId.SearchingForListingId,
    defaultValue: "Searching for Listing Id: '{0}'",
  },
  [FormatContentId.SearchingForOrderId]: {
    id: FormatContentId.SearchingForOrderId,
    defaultValue: "Searching for Order Id: '{0}'",
  },
  [FormatContentId.SearchingForSaleId]: {
    id: FormatContentId.SearchingForSaleId,
    defaultValue: "Searching for Sale Id: '{0}'",
  },
  [FormatContentId.SearchResultPick]: {
    id: FormatContentId.SearchResultPick,
    defaultValue:
      "Searching for '{0}' found {1} results. Click on an item to open it.",
  },
  [FormatContentId.SeatAllocationChangeWarning]: {
    id: FormatContentId.SeatAllocationChangeWarning,
    defaultValue:
      'If you change section by {0} or more, or row by {1} or more, you might need to confirm the change with the marketplace first.',
  },
  [FormatContentId.SeatNumber]: {
    id: FormatContentId.SeatNumber,
    defaultValue: 'Seat {0}',
  },
  [FormatContentId.Section]: {
    id: FormatContentId.Section,
    defaultValue: 'Section {0}',
  },
  [FormatContentId.ShareQuoted]: {
    id: FormatContentId.ShareQuoted,
    defaultValue: 'Share "{0}"',
  },
  [FormatContentId.SwitchTo]: {
    id: FormatContentId.SwitchTo,
    defaultValue: 'Switch To {0}',
  },
  [FormatContentId.TakeMeThereInSeconds]: {
    id: FormatContentId.TakeMeThereInSeconds,
    defaultValue: 'Take me there in {0} seconds...',
  },
  [FormatContentId.TheseAreThePastSalesOnTheWebsiteAndApp]: {
    id: FormatContentId.TheseAreThePastSalesOnTheWebsiteAndApp,
    defaultValue: 'These are the past {0} sales on the website and app',
  },
  [FormatContentId.TheXthCheapestListing]: {
    id: FormatContentId.TheXthCheapestListing,
    defaultValue: 'The {0} cheapest listing',
  },
  [FormatContentId.TicketCount]: {
    id: FormatContentId.TicketCount,
    defaultValue: '{0} ticket(s)',
  },
  [FormatContentId.TicketNumber]: {
    id: FormatContentId.TicketNumber,
    defaultValue: 'Ticket {0}',
  },
  [FormatContentId.TicketPricePercentile]: {
    id: FormatContentId.TicketPricePercentile,
    defaultValue: 'Ticket Price {0}',
  },
  [FormatContentId.TicketTypePriority]: {
    id: FormatContentId.TicketTypePriority,
    defaultValue: '{0} Ticket Type Priority',
  },
  [FormatContentId.TransactionsLastNHour]: {
    id: FormatContentId.TransactionsLastNHour,
    defaultValue: 'Trans. L{0}H',
  },
  [FormatContentId.TransactionsLastNDay]: {
    id: FormatContentId.TransactionsLastNDay,
    defaultValue: 'Trans. L{0}D',
  },
  [FormatContentId.UpdatedNMinutesAgo]: {
    id: FormatContentId.UpdatedNMinutesAgo,
    defaultValue: 'Updated {0} minutes ago',
  },
  [FormatContentId.Uploading]: {
    id: FormatContentId.Uploading,
    defaultValue: 'Uploading {0}...',
  },
  [FormatContentId.UpToXTagsCanBeIncluded]: {
    id: FormatContentId.UpToXTagsCanBeIncluded,
    defaultValue: 'Up to {0} tags can be included in columns.',
  },
  [FormatContentId.UrlNumber]: {
    id: FormatContentId.UrlNumber,
    defaultValue: 'URL {0}',
  },
  [FormatContentId.VisitsLastNHour]: {
    id: FormatContentId.VisitsLastNHour,
    defaultValue: 'Visits L{0}H',
  },
  [FormatContentId.VisitsLastNDay]: {
    id: FormatContentId.VisitsLastNDay,
    defaultValue: 'Visits L{0}D',
  },
  [FormatContentId.WebsitePriceRollupMetric]: {
    id: FormatContentId.WebsitePriceRollupMetric,
    defaultValue: 'Website Price: {0}',
  },
  [FormatContentId.WelcomeUserMessage]: {
    id: FormatContentId.WelcomeUserMessage,
    defaultValue: 'Hello, {0}',
  },
  [FormatContentId.WillDeliverToSecondaryAccount]: {
    id: FormatContentId.WillDeliverToSecondaryAccount,
    defaultValue: 'Tickets will be delivered to my {0} account',
  },
  [FormatContentId.YourSaleMetricsPart2]: {
    id: FormatContentId.YourSaleMetricsPart2,
    defaultValue:
      'are {0} tickets sold with {1} net proceeds and {2} sales margin.',
  },
  [FormatContentId.YourSaleWithStatus]: {
    id: FormatContentId.YourSaleWithStatus,
    defaultValue: 'You have {0} sales {1} for upcoming events.',
  },
};
